import { Injectable } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { P2pAddDonationsModalComponent } from '../../modals/p2p-add-donations-modal/p2p-add-donations-modal.component';
import { first } from 'rxjs/operators';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class ModalP2pAddDonationsService {

  public modalRef: MdbModalRef<any> | null = null;

  constructor(
    private modalService: MdbModalWrapperService,
  ) { }

  open(data, isModalInsideModal = false) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(P2pAddDonationsModalComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog modal-lg',
      data: {data}
    });
    
    if(isModalInsideModal) {
      this.modalRef.onClose.pipe(
        first()
      ).subscribe(() => {
        window['$'](document.body).addClass("modal-open");
      })
    }

    return this.modalRef;
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
